/**
 * Created by KRAE059 on 13.12.2016.
 */
'use strict';

$('.modal-trigger.delete-cart').each(function(_, element) {
    Belimo.SavedCartDeleteModal = {
        getModalHTMLText() {
            return $('#modal-delete-text').html();
        },

        getModalDeleteConfirmationElement() {
            return $('.delete-modal-confirmation');
        },

        showDeleteModal(target) {
            var $target = target;
            var btnDeleteUrl = $target.data('delete-url');
            var btnDeleteText = $target.data('delete-txt');
            var btnCancelText = $target.data('cancel-txt');
            var btnDeleteNextUrl = $target.data('delete-nexturl');
            var modalText = Belimo.SavedCartDeleteModal.getModalHTMLText();
            var buttons = [];

            buttons.push({
                label: btnDeleteText,
                type: 'button',
                callback() {
                    $.ajax({
                        url: btnDeleteUrl,
                        type: 'POST',
                        success() {
                            location.href = btnDeleteNextUrl;
                        }
                    });
                }
            });

            buttons.push({
                label: btnCancelText,
                type: 'reset',
                callback: Belimo.Modal.close
            });

            Belimo.Modal.open(modalText, buttons);
            return '';
        }
    };

    $(element).on('click', function(e) {
        e.preventDefault();
        Belimo.SavedCartDeleteModal.showDeleteModal($(e.currentTarget));
    });
});
